import React from "react";
import BackButton from "../components/BackButton"; 

function TermsAndConditions() {
    return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "50px", fontFamily: "'Poppins', sans-serif" }}>
            
            {/* Header */}
            <div className="pb-5 pt-4 px-3 position-relative overflow-hidden"
                style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <BackButton className="text-white" />
                    <div style={{ width: 30 }}></div>
                </div>
                <div className="text-center pb-3">
                    <h3 className="fw-bolder text-white mb-1">Terms & Conditions</h3>
                    <p className="text-white opacity-75 small mb-0">Last updated: March 2026</p>
                </div>
            </div>

            {/* Content Body */}
            <div className="container px-3" style={{ marginTop: "-30px" }}>
                <div className="card border-0 shadow-sm rounded-4 p-4 animate-up mb-4">
                    <p className="text-muted small mb-4" style={{ lineHeight: "1.6" }}>
                        Welcome to Win11 Fantasy. By accessing or using our platform, you agree to be bound by these Terms & Conditions. Please read them carefully.
                    </p>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-person-check-fill text-danger me-2"></i>1. Eligibility & Restricted States</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            You must be at least 18 years of age to participate in real-money contests on Win11 Fantasy. Based on current Indian laws, users residing in states where fantasy sports are restricted (including but not limited to <b>Assam, Odisha, Telangana, Nagaland, Sikkim, and Andhra Pradesh</b>) are strictly prohibited from participating in any cash contests. Any account found violating this will be immediately suspended without any refunds.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-shield-lock-fill text-danger me-2"></i>2. User Accounts & KYC</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            You are permitted to operate only one (1) single account on Win11. To withdraw winnings, mandatory KYC verification using a valid Government-issued PAN card and Bank Account/UPI matching the PAN name is required. Creating multiple accounts or submitting forged documents is illegal and will result in permanent bans.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-credit-card-fill text-danger me-2"></i>3. Payments, Deposits & Refunds</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            All financial transactions made on the platform are final. Deposit amounts can only be used to join contests and cannot be directly withdrawn. <b>Refund Policy:</b> In the event a match is abandoned, cancelled, or declared void, the entire entry fee will be refunded directly to the user's Win11 wallet within 24 hours.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h6 className="fw-bold text-dark"><i className="bi bi-bank2 text-danger me-2"></i>4. Taxation (TDS) & Withdrawals</h6>
                        <p className="text-muted small" style={{ lineHeight: "1.7" }}>
                            As per the Finance Act 2023, a Tax Deducted at Source (TDS) of 30% will be applicable on Net Winnings at the time of withdrawal or at the end of the financial year. Withdrawals are processed within 24 to 48 working hours, subject to successful KYC verification and banking operations.
                        </p>
                    </div>

                    <div className="policy-section mb-0 border-0">
                        <h6 className="fw-bold text-dark"><i className="bi bi-exclamation-triangle-fill text-danger me-2"></i>5. Breach of Terms</h6>
                        <p className="text-muted small mb-0" style={{ lineHeight: "1.7" }}>
                            Win11 reserves the right to suspend or deactivate any account, and forfeit any balances, if a user is found engaged in fraudulent activities, collusion, or violating any terms listed herein. 
                        </p>
                    </div>
                </div>
            </div>

            <style>{`
                .animate-up { animation: fadeInUp 0.4s ease-out both; }
                .policy-section { border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px; }
                @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}

export default TermsAndConditions;